export default {
  methods: {
    format_price(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    generalNumberFormat(value, decimales = 2){
      if(value == null) {
        return 0;
      }
      return this.format_price(value, decimales);
    },
    decimalsFormat(value, decimales = 2){
      if(value == null){ return 0;}
      else{
        return value.toFixed(decimales);
      }
    },
    floatValue(str){
      if(str == null) return 0;
      else {
        return parseFloat(str);
      }
    },
    explicitMoneyFormat(value, decimales = 2) {
      if(value == null) return "";
      else {
        return "$" + this.format_price(value, decimales);
      }
    },
    intDigitsFormat(value){
      if(value == null) {
        return 0
      }
      else {
        return this.format_price(value, 0);
      }
    },
    mxnFormat(value){
      if(!value){ return "$0";}
      else {
        return "$" + this.format_price( parseInt(value), 0) + " MXN";
      }
    },
    moneyFormat(value){
      if(!value){ return "$0";}
      else {
        return "$" + this.format_price( parseInt(value), 0);
      }
    },
    decimalPercentFormat(value, decimales = 2){
      if(!value) return "0%";
      else {
        return (value * 100).toFixed(decimales) + "%";
      }
    },
    roundedFormat(value, decimales = 2){
      if(!value){ return 0; }
      else {
        let c = value.toFixed(decimales);
        let cd = Math.round(c);
        return cd.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    phoneFormat(value){
      if(!value) return value
      else {
        return '(' + value.substr(0, 2) + ') ' + value.substr(2, 4) + '-' + value.substr(6,4)
      }
    },
    truncateDecimals(value){
      return String(value).includes('.')?String(value).split('.')[0]:value;
    },
    explicitMoneyFormatTrunc(value, decimales = 2) {
      return this.truncateDecimals(this.explicitMoneyFormat(value, decimales));
    },
    intDigitsFormatTrunc(value) {
      return this.truncateDecimals(this.explicitMoneyFormat(value));
    },
    parseMillions(value){
      return parseInt(value / 1000000);
    }
  }
}